export default __webpack_public_path__ + "static/media/release2.131460d7.jpeg";